<template>
  <div class="absolute h-[calc(100%-140px)] w-368px right-0px top-66px z-100">
    <div class="p-10px component-container h-full">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        防腐保温
      </div>
      <div class="mt-10px text-white border-2px p-10px rounded-5px border-[#409eff]">
        <div
          class="flex text-12px leading-24px"
          v-for="(item, index) in basicAttributes"
          :key="index"
        >
          <div class="text-[#c3c3c3]">{{ item.label }}：</div>
          <div class="flex-1 truncate">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'anticorrosionInsulationDetail',
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      basicAttributes: [],
    }
  },
  watch: {
    'transferProps.tagCode': {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
    },
  },
  methods: {
    init() {
      console.log(this.transferProps, 'transferProps')
      const detailData = {
        diameter: this.transferProps.nominalDiameter
          ? Number(this.transferProps.nominalDiameter.match(/[-+]?\d*\.?\d+/)[0])
          : null,
        length: this.transferProps.length,
        thickness: this.transferProps.insThk ? Number(this.transferProps.insThk) : null,
      }
      let surfaceArea = null
      let antiCorrosive = null
      let volume = null
      if (detailData.diameter && detailData.length) {
        surfaceArea = Number(
          (Math.PI * detailData.diameter * Math.pow(0.1, 3) * detailData.length).toFixed(4)
        )
        antiCorrosive = surfaceArea
        if (detailData.thickness) {
          volume =
            Math.PI *
            (detailData.thickness * Math.pow(0.1, 3) * 1.033) *
            (detailData.diameter + detailData.thickness * 1.033) *
            Math.pow(0.1, 3) *
            detailData.length
        }
      }
      console.log(volume, 'volume')
      this.basicAttributes = [
        {
          code: 'diameter',
          label: '管径(mm)',
          value: detailData.diameter,
        },
        {
          code: 'length',
          label: '长度(mm)',
          value: detailData.length ? detailData.length * 1000 : '',
        },
        {
          code: 'surfaceArea',
          label: '外表面积(㎡)',
          value: surfaceArea,
        },
        {
          code: 'antiCorrosive',
          label: '防腐面积(㎡)',
          value: antiCorrosive,
        },
        {
          code: 'thickness',
          label: '保温厚度(mm)',
          value: detailData.thickness,
        },
        {
          code: 'volume',
          label: '保温体积(m³)',
          value: volume ? Number(volume.toFixed(5)) : null,
        },
      ]
    },
  },
  created() {
    if (this.transferProps.tagCode) {
      this.init()
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}

</style>
